import React, { Component } from "react";
import tingle from "tingle.js";

/** Modal high order based on tingle js (http://robinparisi.github.io/tingle/) - look for OPTIONS and API docs **/

function modalBase(WrappedComponent) {
	return class extends Component {
		constructor(props) {
			super(props);

			this.modalInstanceName = new tingle.modal({
				footer: true,
				cssClass: props.cssClass ? props.cssClass : [],
				closeMethods: ['button'],
				closeLabel: "Fechar",
				onClose: function() {
					typeof props.onClose === "function" ? props.onClose() : null;
				}
			});
		}

		render() {
			return <WrappedComponent {...this.props} modalInstance={this.modalInstanceName} />;
		}
	};
}

export default modalBase;
